import { gql } from '@apollo/client';
import SPECIFICATION_HEADER from '../fragments/SPECIFICATION_HEADER';
const GET_SPECIFICATION_FOLDER_CONTENTS_DATA = gql `
  ${SPECIFICATION_HEADER}
  fragment FolderTileData on ModelSpecificationFolderNode {
    id
    name
    modelSpecificationsCount
    foldersCount
    createdDate
    modifiedDate
    canBeRemoved
    parentFolder {
      id
      name
    }
  }
  fragment FolderContentsData on ModelSpecificationFolderNode {
    id
    name
    modelSpecifications(
      search: $search
      orderBy: $orderBy
      first: $first
      after: $after
      isActive: true
      state: $state
      statusId: $statusId
      categoryId: $categoryId
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...SpecificationHeaderFragment
        }
      }
    }
    folders(search: $search, orderBy: $orderBy, isActive: true) {
      edges {
        node {
          ...FolderTileData
        }
      }
    }
    parentFolder {
      id
      name
    }
    canBeRemoved
    path {
      id
      name
    }
  }

  query getSpecificationFolderContentsData(
    $modelSpecificationFolderId: ID!
    $search: String
    $orderBy: String
    $first: Int
    $after: String
    $state: [String]
    $statusId: [ID]
    $categoryId: [ID]
  ) {
    node(id: $modelSpecificationFolderId) {
      ...FolderContentsData
    }
  }
`;
export default GET_SPECIFICATION_FOLDER_CONTENTS_DATA;
